import { render, staticRenderFns } from "./CountrySwitcher.vue?vue&type=template&id=6e992854&scoped=true"
import script from "./CountrySwitcher.vue?vue&type=script&setup=true&lang=ts"
export * from "./CountrySwitcher.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CountrySwitcher.vue?vue&type=style&index=0&id=6e992854&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e992854",
  null
  
)

export default component.exports